import React from "react";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls/Card";
import Loader from "react-loader-spinner";
import { Button, Modal, Dropdown, DropdownButton } from "react-bootstrap";
import PopupModal from '../modal/popupmodal';
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import { Animated } from "react-animated-css";
import { Switch } from '@material-ui/core';
import Select from 'react-select';
import UserRoleForm from "../User/UserRole";


class AddFacilityUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IsLoading: false,
            roleID: props.roleID,
            facilityID: props.facilityID,
            facilityName: props.facilityName,
            selectUserOptions: [],
            userList: [],
            saveButtonDisabled: false,
            selectedUserList: [],
            formValidated: false,
            showAddUserModal: false,
            currentUser: null,
            facilityUser:
            {
                fkOperatorsPurchasingGroupId: props.operatorsPurchasingGroupID != '' ? props.operatorsPurchasingGroupID : null,
                fkOwnershipHeadquartersId: props.ownershipHeadquartersID != '' ? props.ownershipHeadquartersID : null,
                fkFacilityId: props.facilityID != '' ? props.facilityID : null,
                facilityUserList: []
            }

        };

        this.formRef = React.createRef();
    }

    componentDidMount() {
        this.getAllUsers();
        this.setState({ 
            IsLoading: true 
        });
    }
    handleOpenModal = (user = null) =>{

        this.setState({
            showAddUserModal: true,
            currentUser: user,
            saveButtonDisabled: true,
        });

        this.setState(prevState =>({
            facilityUser: {
                ...prevState.facilityUser,
                isAdd: user ? false : true
            }
        }));
    };

    handleCloseModal = () => {
        this.setState({
            showAddUserModal: false,
            currentUser: null,
            saveButtonDisabled: true, // Reset save button state when closing
        });
    };

    // Callback to handle validation status from UserRoleForm
    handleValidationChange = (isValid) => {
        this.setState({
            saveButtonDisabled: !isValid
        });
    };

    handleSelectedUser = selectedUserList => {
        this.setState({ selectedUserList });
    };

    async getUserByRoleID(e) {
        try {
            const userMap = new Map();
            const roles = [Common.UserRole.LevelII, Common.UserRole.MDSCoordinator, Common.UserRole.LevelI, Common.UserRole.CorporateClinician, Common.UserRole.RegionalClinician];
            
            const forGentell = false;

            for (let role of roles) {
                const response = await Api.getRequestById(
                    Api.Uri_GetUserByRoleID,
                    role,
                    forGentell
                );

                if (response.data.result.length > 0) {
                    // response.data.result
                    //     .map((v) => (
                    //         // key is UserID and value is UserName
                    //         users.push({ value: v.key, label: v.value })
                    //     ));

                    response.data.result.forEach((v) => {
                    // v.key is UserID and v.value is UserName
                    if (v.key && v.value) {
                        userMap.set(v.key, { value: v.key, label: v.value });
                    }
                });
                }
            }

            let users = Array.from(userMap.values());
            
            // Sort users by the label (username) before setting state
            users.sort((a, b) => {
                if (a.label && b.label) {
                    return a.label.localeCompare(b.label);
                }
                return 0;
            });

            this.setState({ selectUserOptions: users });
        } catch (error) {
            console.error('An error occurred:', error);
        }
    }

    getAllUsers = () => {
        
        Api.getRequestQry(Api.apiUrls.getFacilityUsers,
            "?operatorsPurchasingGroupID=" + this.props.operatorsPurchasingGroupID +
            "&ownershipHeadquartersID=" + this.props.ownershipHeadquartersID +
            "&facilityID=" + this.props.facilityID)
            .then((response) => {
                
                // this.setState({ selectedUserList: response.data.result });
                this.setAllUserList(response.data.result);
                let userArray = [];
                response.data.result.map(usr => {
                    // if (!product.withOtherButtons) {
                    //     return null;
                    // }
                    if(usr.active==true){
                    userArray.push(
                        {
                            value: usr.fkUserId, id: usr.id, label: usr.userName
                        }
                    )
                    }
                }
                )
                this.setState({ selectedUserList: userArray });
                Common.LoadDataTable("repFirmList");
                this.getUserByRoleID();
            })
            .catch(function (error) {

            });

        //    editUserModal.hideModal();
    }

    // setAllUserList = (list) => {
    //     let rows = [];
        
    //     try {
    //         for (var i = 0; i < list.length; i++) {
    //             const obj = list[i];
    //             {console.log(obj)}
    //             rows.push(
    //                 <tr key={i.toString()}>

    //                 <td>
    //                     {obj.userName}
    //                 </td>

    //                 <td>
    //                     <Switch
    //                         checked={obj.active}
    //                         // onChange={handleUserStatus(obj.userID)}
    //                         // onClick={handleUserStatus(obj)}
    //                         value="Status"
    //                         inputProps={{ 'aria-label': 'secondary checkbox' }}
    //                     />
    //                 </td>

    //                 <td>
    //                     <Button
    //                         variant="primary"
    //                         size="sm"
    //                         onClick={() => 
    //                             this.handleOpenModal(obj)
    //                         }
    //                     >
    //                         Edit User
    //                     </Button>

    //                     {/* <Button variant="success" className="mr-5 px-10" size="sm" onClick={e => this.onSubmit(e)}>Submit</Button> */}
    //                 </td>
    //             </tr>);
    //         }

    //         this.setState({ userList: rows });
    //         this.setState({ IsLoading: true });

    //     } catch (error) {
    //     }
    // }

    setAllUserList = (list) => {
        this.setState({ userList: list, IsLoading: true });
    };

    toggleActive = (index) => {
        this.setState(prev => {
            const updatedUserList  = [...prev.userList];
            updatedUserList [index].active = !updatedUserList [index].active;
            
            let updatedSelected = [...prev.selectedUserList];
            
            if (updatedUserList[index].active) 
                {
                // Add user if toggled ON
                updatedSelected.push(
                    {
                        value: updatedUserList[index].fkUserId, id: updatedUserList[index].id, label: updatedUserList[index].userName
                    }
                );
            } 
            else {
                // Remove user if toggled OFF
                updatedSelected = updatedSelected.filter(
                    (u) => u.label !== updatedUserList[index].userName
                );
            }

            return { 
                userList: updatedUserList,
                selectedUserList: updatedSelected,
            };
        });
    };

    renderRows = () => {
        return this.state.userList.map((obj, i) => (
            <tr key={i}>
            <td>{obj.email}</td>
            <td align="center">
                <Switch
                checked={obj.active}
                onChange={() => this.toggleActive(i)}
                value="Facility Access"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
            </td>
            <td align="center">
                <Button
                variant="primary"
                size="sm"
                onClick={() => this.handleOpenModal(obj)}
                >
                Edit User
                </Button>
            </td>
            </tr>
        ));
    };

    onSubmit() {
        
        // if (this.form.checkValidity() === false) {
        //     // this.form.preventDefault();
        //     // this.form.stopPropagation();
        //     let _state = this.state;
        //     _state.formValidated = true;
        //     this.setState(_state);
        // } else {
        this.setState({ IsLoading: false });

        const obj = this.state.facilityUser;
        obj.facilityUserList = this.state.selectedUserList;

        obj.isAdd = null;


        Api.postRequest(Api.apiUrls.upsertFacilityUser, obj).then((res) => {
            if (res.data.success) {
                this.setState({ IsLoading: true });
                Common.showSuccessAlertAutoClose(
                    "Data Saved Successfully",
                    "success",
                    "Success!",
                    3000
                );
                this.getAllUsers();
                this.handleCloseModal();
            } else {
                Common.showSuccessAlert(
                    res.data.message,
                    "error",
                    "Error!",
                    3000
                );
            }
        });
        // }
    }

    handleSaveUser = async (formData) => {

        this.formRef.current.setState({ IsLoading: false });

        const obj = this.state.facilityUser

        // if(!formData.id){
        //     this.state.selectedUserList.push(
        //     {
        //         value: formData.fkUserId, id: formData.id, label: formData.lastName + " " + formData.firstName
        //     }
        // )}

        this.state.selectedUserList.push(
            {
                value: formData.fkUserId, id: formData.id, label: formData.lastName + " " + formData.firstName
            }
        )

        obj.facilityUserList = this.state.selectedUserList
        obj.FirstName = formData.firstName
        obj.LastName = formData.lastName
        obj.Email = formData.email
        obj.fkUserId = formData.fkUserId
        obj.roleID = formData.roleID

        Api.postRequest(Api.apiUrls.upsertFacilityUser, obj).then((res) => {
            if (res.data.success) {
                
                this.formRef.current.setState({ IsLoading: true });
                Common.showSuccessAlertAutoClose(
                    "Data Saved Successfully",
                    "success",
                    "Success!",
                    3000
                );
                this.getAllUsers();
                this.handleCloseModal();
            } else {
                Common.showSuccessAlert(
                    res.data.message,
                    "error",
                    "Error!",
                    3000
                );

                this.handleCloseModal();
            }
        });

    };


    render() {
        return (
            <>

                {(this.state.IsLoading == true) ?
                    <div>
                        <Form
                            validated={this.state.formValidated}
                        >
                            <>
                                <Card className="example example-compact">
                                    <CardHeader title="Users List" toolbar={
                                    
                                        <div className="card-toolbar">
                                            <div className="example-tools">
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => {this.handleOpenModal()}} 
                                                >
                                                    Add User
                                                </Button>
                                            </div>
                                        </div>
                                    } 
                                    />

                                    <CardBody>
                                        {(this.state.roleID != 'Level I') ? 
                                        <div className="row mt-2" id="changed">

                                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="ThisFacilityBelongsTo">
                                                        Users

                                                    </label>

                                                    {/* <select
                                                    className="form-control form-control-sm"
                                                    name="fkUserId"
                                                >
                                                    <option></option>
                                                    {this.state.selectUserOptions}
                                                </select> */}
                                                    <Select isMulti='true'
                                                        value={this.state.selectedUserList}
                                                        hideSelectedOptions={true}
                                                        onChange={this.handleSelectedUser}
                                                        options={this.state.selectUserOptions} />



                                                </div>
                                            </div>

                                        </div>
                                        : null
                                        }   

                                        {/* <div className="d-flex justify-content-end py-3">
                                            <Button variant="success" className="mr-5 px-10" size="sm" onClick={e => this.onSubmit(e)}>Submit</Button>
                                        </div> */}


                                        <table
                                            className="table table-striped table-hover table-sm table-bordered"
                                            id="repFirmList"
                                        >
                                            <thead>
                                                <tr>
                                                    <th data-priority="1">User Name</th>
                                                    <th>Facility Access</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* {this.state.userList} */}
                                                {this.renderRows()}
                                            </tbody>
                                        </table>
                                    </CardBody>
                                </Card>


                            </>
                        </Form>


                    </div> :
                    <div className="d-flex justify-content-center">
                        <Loader
                            type="Puff"
                            color="#00BFFF"
                            height={50}
                            width={50}
                        />
                    </div>
                }

                {/* Popup / Modal */}

                {/* <PopupModal
                    size="lg" 
                    title="Add User"
                    buttonPress = {this.handleOpenModal}
                    show={this.state.showAddUserModal}
                    onHide = {this.handleCloseModal}
                >
                    <UserRoleForm onSave = {this.handleCloseModal} />

                </PopupModal> */}

                <Modal 
                    aria-labelledby="userModal"
                    scrollable 
                    backdrop="static"
                    // dialogClassName="modal-90w"
                    keyboard={false}
                    show={this.state.showAddUserModal} 
                    onHide={this.handleCloseModal} 
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="userModal">
                            {this.state.currentUser?.id ? "Edit User" : "Add User"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                    <UserRoleForm 
                        ref = {this.formRef}
                        user={this.state.currentUser}
                        // onSave={this.handleCloseModal}
                        onSave={this.handleSaveUser}
                        facilityName= {this.state.facilityName}
                        userList = {this.state.userList}
                        saveButtonDisabled = {this.state.saveButtonDisabled}
                        onValidationChange={this.handleValidationChange}
                        isEditMode={!!this.state.currentUser}
                        roleID={this.state.roleID}
                        
                    />

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="danger" onClick={this.handleCloseModal}>
                            Close
                        </Button>

                        <Button 
                            variant="primary" 
                            onClick={()=>{
                                this.formRef.current.handleSubmit()
                                // this.handleCloseModal
                            }}
                            disabled={this.state.saveButtonDisabled}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }
}

export default AddFacilityUser;
